import { addBrowseCount, addDownloadCount, addRemark, deleteFile, getCourseFileList, getCourseList, getInspection, toClosingReview } from "@/api/course.js";
const state = {
    courseList: {
        params: {
            type: "0",
            ktsx: "",
            nf: "",
            gsbm: "",
            ssjd: "",
            sfcx: "",
            sflx: "",
            sfjx: "",
            pswy: "",
            ktds: "",
            fzr: "",
            ktmc: "",
            page: 1,
            pageSize: 10,
        },
        list: {
            item: [],
            count: 0,
            listLoading: true
        },
        fileList: {
            item: [],
            count: 0,
            listLoading: true
        },
        courseFeedbackInfo: []
    },

};
const mutations = {
    fetchCourseList(state, payload) {
        if (payload.res.code == 0) {
            state.courseList.params = payload.params;
            state.courseList.list.item = payload.res.data;
            state.courseList.list.count = payload.res.count;
            state.courseList.list.listLoading = false;
        }
    },
    fetchCourseFileList(state, payload) {
        if (payload.res.code == 0) {
            state.courseList.fileList.item = payload.res.data;
            state.courseList.fileList.count = payload.res.count;
            state.courseList.fileList.listLoading = false;
        }
    },
    setInspection(state, payload) {
        if (payload.res.code == 0) {
            state.courseFeedbackInfo = payload.res.data.courseFeedbackInfo;
        }
    }
};
const actions = {
    fetchCourseListAction(context, payload) {
        return new Promise((resolve, reject) => {
            getCourseList(payload)
                .then((res) => {
                    context.commit("fetchCourseList", { res, params: payload });
                    resolve(res);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    fetchCourseFileListAction(context, { params }) {
        return new Promise((resolve, reject) => {
            getCourseFileList(params)
                .then((res) => {
                    context.commit("fetchCourseFileList", { res });
                    resolve(res);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    fetchUpdateBzAction(context, { params }) {
        return new Promise((resolve, reject) => {
            addRemark(params)
                .then((res) => {
                    resolve(res);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    fetchDeleteFileAction(context, { fileId }) {
        return new Promise((resolve, reject) => {
            deleteFile(fileId)
                .then((res) => {
                    resolve(res);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    addBrowseCountAction(context, { fileId }) {
        return new Promise((resolve, reject) => {
            addBrowseCount(fileId)
                .then((res) => {
                    resolve(res);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    addDownloadCountAction(context, { fileId }) {
        return new Promise((resolve, reject) => {
            addDownloadCount(fileId)
                .then((res) => {
                    resolve(res);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    saveAndToClosingReviewAction(context, { courseId, step }) {
        return new Promise((resolve, reject) => {
            toClosingReview(courseId, step)
                .then((res) => {
                    resolve(res);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    //管理组检查情况
    fetchInspectionAction(context, { fileId }) {
        return new Promise((resolve, reject) => {
            getInspection(fileId)
                .then((res) => {
                    context.commit("setInspection", { res });
                    resolve(res);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },

};
export default {
    namespaced: true,
    state,
    mutations,
    actions,
};
